/* SILETH – Free Piece: Gold Injection + Detection Fix (v6.1)
   v6: Punkte-Navigation komplett uebernommen (live-Update beim Wischen,
   korrekte Anzahl inkl. See-more-Slide, klickbar), See-more-Slide als
   echte Karte im Stil der uebrigen Slides. GOLD ist Standard-Tab.
   v6.1: Gold-Slides ueberschreiben nur noch .sfp-piece-name, nicht mehr
   die Slide-Ueberschrift. */
(function () {
  if (window.__SILETH_FP_GOLD__) return;
  window.__SILETH_FP_GOLD__ = true;

  var GOLD_MAP = {
    47757025280339: { goldId: 47757025247571, handle: '3mm-cuban-bracelet',        name: 'Cuban Bracelet 3MM' },
    47757069484371: { goldId: 47757069451603, handle: 'original-pendant-necklace', name: 'Original Pendant' },
    47757018562899: { goldId: 47757018530131, handle: 'compass-necklace',          name: 'Compass Necklace' },
    47757056180563: { goldId: 47757056147795, handle: '6mm-cuban-bracelet',        name: 'Cuban Bracelet 6MM' },
    47757058343251: { goldId: 47757058310483, handle: '6mm-cuban-chain',           name: 'Cuban Necklace 6MM' }
  };

  function isDE() {
    return /\/(de|de-de)(\/|$)/i.test(window.location.pathname) ||
           (document.documentElement.lang || '').toLowerCase().indexOf('de') === 0;
  }
  function seeAllHref() { return isDE() ? '/de-de/collections/free-piece' : '/collections/free-piece'; }

  var detectBusy = false;
  function applyDetectionFix() {
    var btns = document.querySelectorAll('[data-free-piece-button]');
    if (!btns.length || detectBusy) return;
    detectBusy = true;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        detectBusy = false;
        if (!cart || !cart.items) return;
        var hasFreePiece = cart.items.some(function (it) {
          var type  = String(it.product_type  || '').toLowerCase();
          var title = String(it.product_title || '').toLowerCase();
          var isWatch = type.indexOf('watch') > -1 || title.indexOf('watch') > -1;
          var fin  = parseInt(it.final_line_price    || it.line_price     || 0, 10);
          var orig = parseInt(it.original_line_price || it.original_price || 0, 10);
          return !isWatch && fin === 0 && orig > 0;
        });
        btns.forEach(function (btn) {
          var want = hasFreePiece
            ? (isDE() ? 'GRATIS PIECE HINZUGEFÜGT ✓' : 'FREE PIECE ADDED ✓')
            : (isDE() ? 'GRATIS PIECE SICHERN' : 'GET FREE PIECE');
          if (btn.textContent.trim() !== want) btn.textContent = want;
          if (hasFreePiece) {
            if (!btn.disabled) btn.disabled = true;
            if (btn.getAttribute('aria-disabled') !== 'true') btn.setAttribute('aria-disabled', 'true');
            if (btn.style.opacity !== '0.55') btn.style.opacity = '0.55';
            if (btn.style.cursor !== 'not-allowed') btn.style.cursor = 'not-allowed';
          } else {
            if (btn.disabled) btn.disabled = false;
            if (btn.hasAttribute('disabled')) btn.removeAttribute('disabled');
            if (btn.hasAttribute('aria-disabled')) btn.removeAttribute('aria-disabled');
            if (btn.style.opacity !== '1') btn.style.opacity = '1';
            if (btn.style.cursor !== 'pointer') btn.style.cursor = 'pointer';
          }
        });
      })
      .catch(function () { detectBusy = false; });
  }

  var imgCache = {};
  function setSlideImage(slide, src) {
    var img = slide.querySelector('.sfp-slide-image img');
    if (img) { img.src = src; img.srcset = ''; }
  }
  function fetchGoldImage(slide, handle, goldVariantId) {
    var key = handle + ':' + goldVariantId;
    if (imgCache[key]) { setSlideImage(slide, imgCache[key]); return; }
    fetch('/products/' + handle + '.json', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var variants = (data.product && data.product.variants) || [];
        var v = variants.find(function (x) { return x.id === goldVariantId; });
        var imgId = v && v.image_id;
        var images = (data.product && data.product.images) || [];
        var img = images.find(function (i) { return i.id === imgId; }) || images[0];
        if (img) { imgCache[key] = img.src; setSlideImage(slide, img.src); }
      })
      .catch(function () {});
  }

  function makeProdSeeMore() {
    var de = isDE();
    var div = document.createElement('div');
    div.className = 'sfp-slide sfp-slide--see-more';
    div.innerHTML =
      '<a class="sfp-slide-image sfp-see-more-tile" href="' + seeAllHref() + '" aria-label="' + (de ? 'Alle Schmuckstücke ansehen' : 'See all jewelry pieces') + '"><span class="sfp-see-more-arrow">→</span></a>' +
      '<div class="sfp-slide-content">' +
        '<div class="sfp-slide-title">' + (de ? 'DIE GANZE KOLLEKTION' : 'THE FULL COLLECTION') + '</div>' +
        '<div class="sfp-slide-subtitle">' + (de ? 'Dein Gratis-Stück kannst du aus allen Schmuckstücken wählen – nicht nur aus diesen fünf.' : 'You can pick your free piece from every jewelry item – not just these five.') + '</div>' +
        '<a class="sfp-btn sfp-btn--link" href="' + seeAllHref() + '">' + (de ? 'ALLE ANSEHEN' : 'SEE ALL') + '</a>' +
      '</div>';
    return div;
  }

  function rebuildDots(root) {
    var dotsBox = root.querySelector('.sfp-dots');
    if (!dotsBox) return;

    function tracks() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-sfp-track], .sfp-slider-track'));
    }
    function visibleTrack() {
      var list = tracks();
      for (var i = 0; i < list.length; i++) {
        if (!list[i].classList.contains('sfp-track--hidden')) return list[i];
      }
      return list[0] || null;
    }

    var t0 = visibleTrack();
    if (!t0) return;
    var count = t0.querySelectorAll('.sfp-slide').length;
    if (!count) return;

    dotsBox.innerHTML = '';
    var dots = [];
    for (var i = 0; i < count; i++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sfp-dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Slide ' + (i + 1));
      (function (idx) {
        b.addEventListener('click', function () {
          var t = visibleTrack();
          if (t) t.scrollTo({ left: idx * t.clientWidth, behavior: 'smooth' });
        });
      })(i);
      dotsBox.appendChild(b);
      dots.push(b);
    }

    var raf = null;
    function update() {
      raf = null;
      var t = visibleTrack();
      if (!t || !t.clientWidth) return;
      var idx = Math.round(t.scrollLeft / t.clientWidth);
      if (idx < 0) idx = 0;
      if (idx > dots.length - 1) idx = dots.length - 1;
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === idx); });
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(update); }

    tracks().forEach(function (t) {
      t.addEventListener('scroll', onScroll, { passive: true });
    });

    root._sfpDotsUpdate = update;
    update();
  }

  function injectGoldSlides(root) {
    if (root.dataset.sfpGoldDone) return;
    root.dataset.sfpGoldDone = '1';

    var silverTrack = root.querySelector('[data-sfp-track="silver"], .sfp-slider-track');
    if (!silverTrack) return;
    silverTrack.setAttribute('data-sfp-track', 'silver');

    var shell = silverTrack.closest('.sfp-slider-shell') || silverTrack.parentNode;
    var tabs = document.createElement('div');
    tabs.className = 'sfp-tabs';
    tabs.innerHTML =
      '<button type="button" class="sfp-tab is-active" data-sfp-tab="gold">GOLD</button>' +
      '<button type="button" class="sfp-tab" data-sfp-tab="silver">' +
        (isDE() ? 'SILBER' : 'SILVER') +
      '</button>';
    shell.parentNode.insertBefore(tabs, shell);

    var goldTrack = silverTrack.cloneNode(true);
    goldTrack.setAttribute('data-sfp-track', 'gold');
    silverTrack.classList.add('sfp-track--hidden');
    silverTrack.parentNode.insertBefore(goldTrack, silverTrack.nextSibling);

    goldTrack.querySelectorAll('[data-free-piece-button]').forEach(function (btn) {
      var silverId = Number(btn.getAttribute('data-variant-id'));
      var m = GOLD_MAP[silverId];
      if (!m) return;
      btn.setAttribute('data-variant-id', String(m.goldId));
      var slide = btn.closest('.sfp-slide');
      if (slide) {
        var nameEl = slide.querySelector('.sfp-piece-name');
        if (nameEl) nameEl.textContent = m.name;
        fetchGoldImage(slide, m.handle, m.goldId);
      }
    });

    silverTrack.appendChild(makeProdSeeMore());
    goldTrack.appendChild(makeProdSeeMore());

    var activeMat = 'gold';
    tabs.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-sfp-tab]');
      if (!tab) return;
      var mat = tab.getAttribute('data-sfp-tab');
      if (mat === activeMat) return;
      activeMat = mat;
      tabs.querySelectorAll('[data-sfp-tab]').forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-sfp-tab') === mat);
      });
      silverTrack.classList.toggle('sfp-track--hidden', mat !== 'silver');
      goldTrack.classList.toggle('sfp-track--hidden', mat !== 'gold');
      if (root._sfpDotsUpdate) root._sfpDotsUpdate();
    });

    rebuildDots(root);
  }

  function tryInit() {
    var root = document.querySelector('[data-sfp-root]');
    if (!root) return false;
    setTimeout(function () { injectGoldSlides(root); applyDetectionFix(); }, 400);
    return true;
  }
  if (!tryInit()) {
    var mo1 = new MutationObserver(function () { if (tryInit()) mo1.disconnect(); });
    mo1.observe(document.documentElement, { childList: true, subtree: true });
  }

  function refreshAll() { applyDetectionFix(); }

  ['cart:refresh', 'cart:updated', 'cart:item-added', 'cart:change'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      setTimeout(refreshAll, 350);
      setTimeout(refreshAll, 1000);
    });
  });

  try {
    var _fetch = window.fetch;
    window.fetch = function () {
      var u = arguments[0];
      var url = (u && u.url) ? u.url : String(u || '');
      var p = _fetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(refreshAll, 350); setTimeout(refreshAll, 1100); });
      }
      return p;
    };
  } catch (e) {}

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(refreshAll, 350); });
  } else {
    setTimeout(refreshAll, 350);
  }
})();
